@use "../../../../shared/scss" as *;

:host {
  display: block;

  .spinner {
    display: flex;
    position: relative;
    justify-content: center;
    inline-size: 100%;
    margin-block-start: p-px-to-rem(24px);
  }

  .city-select-form-field {
    padding-block-start: p-px-to-rem(24px);
  }

  .title-container {
    display: flex;
    flex-direction: row;
    border: 2px solid rgb(107, 109, 112);
    border-radius: 5px;

    transition: background-color 0.24s ease;
    margin-block: 0;
    margin-inline: 0;
    min-block-size: p-px-to-rem(54px);

    phn-p-text {
      padding-inline-start: 19px;
    }

    phn-p-icon {
      margin-inline-end: p-px-to-rem(16px);
      padding-block-start: -8px;
      outline: 0;
    }

    div.text-limit {
      inline-size: 80%;
    }
  }
}
